import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../Home/components/Navbar';
import { Footer } from '../Home/components/Footer';
import { SEO } from '../../components/SEO/SEO';
import './About.css';

export const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page-wrapper">
      <SEO 
        title="About Hobi Hub | Redefining Experiences"
        description="Discover the story behind Hobi Hub. We are building the world's most curated platform for hobbies, connection, and personal growth."
        keywords="Hobi Hub story, about hobi, experience platform, curated hobbies, lifestyle branding"
        canonicalUrl="https://hobi.co.in/about"
      />
      

      {/* --- PREMIUM HERO --- */}
     <section className='hero-bg'>
             <Navbar dark={false} />
             
             <div className="hero">
               <div className="hero-container">
                 <div className="hero-box">
                   <div className="hero-center">
                     <h1 className="hero-h1" style={{ opacity: 1 }}>About Us</h1>
                     <div className="home-desc" style={{ opacity: 1 }}>
                       <p className="hero-p">
                        Discover experiences that match your vibe. Our Mission Our Story Our Vision
                       </p>
                     </div>
                   </div>
                   <div className="hero-bottom" style={{ opacity: 1 }}>
                     <img
                       src="/images/bg-edited.svg"
                       loading="lazy"
                       alt="Hobi Hub Blogs"
                     />
                   </div>
                 </div>
               </div>
             </div>
           </section>
      {/* --- OUR MISSION (Split Layout) --- */}
      <section className="info-block">
        <div className="container-medium">
          <div className="info-grid">
            <div className="info-text">
              <h3 className="heading-italic">Our Mission</h3>
              <h2>Kill the Routine. <br/>Save the Passion.</h2>
              <p>
                In a world of digital noise, we bring you back to the physical. 
                Whether it's the tactile feel of clay, the rhythm of a dance floor, 
                or the rush of an outdoor trail—our mission is to connect you with 
                experiences that make you feel alive. No more scrolling, just doing.
              </p>
            </div>
            <div className="info-image-wrapper">
              <img 
                src="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=1200" 
                alt="Our Team" 
                className="info-image" 
              />
            </div>
          </div>
        </div>
      </section>

      {/* --- OUR STORY (Reverse Split Layout) --- */}
      <section className="info-block" style={{ background: '#fdfdfd' }}>
        <div className="container-medium">
          <div className="info-grid reverse">
            <div className="info-text">
              <h3 className="heading-italic">The Core</h3>
              <h2>Curated by Humans. <br/>Not Algorithms.</h2>
              <p>
                We don't believe in bulk. We believe in quality. Every host on Hobi Hub 
                undergoes a rigorous verification process. We personally vet the vibes, 
                the skills, and the safety, ensuring that every booking is a premium 
                memory in the making.
              </p>
            </div>
            <div className="info-image-wrapper">
              <img 
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&q=80&w=1200" 
                alt="Culture" 
                className="info-image" 
              />
            </div>
          </div>
        </div>
      </section>

      {/* --- FEATURES GRID --- */}
      <section className="features-container">
        <div className="container-medium">
          <div className="feature-grid-header" style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 className="about-hero-h1" style={{ fontSize: '3rem' }}>Why Choose Hobi?</h2>
          </div>
          <div className="features-grid">
            <div className="feature-card-premium">
              <div className="feature-icon-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
              </div>
              <h3>Premium Quality</h3>
              <p>Top-tier equipment, venues, and hosts for every single experience.</p>
            </div>
            <div className="feature-card-premium">
              <div className="feature-icon-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
              </div>
              <h3>Vibrant Community</h3>
              <p>Meet people who share your passion. Build lifelong friendships.</p>
            </div>
            <div className="feature-card-premium">
              <div className="feature-icon-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
              </div>
              <h3>Secure & Seamless</h3>
              <p>Instant booking and 100% secure payments through Razorpay.</p>
            </div>
          </div>
        </div>
      </section>

      {/* --- CTA SECTION --- */}
      <section className="about-cta">
        <div className="container-medium">
          <div className="cta-box-premium">
            <h2>Ready to find your flow?</h2>
            <Link to="/categories" className="cta-btn-premium">Explore Experiences</Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};


